import React, { Component } from 'react'
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  FormFeedback,
} from 'reactstrap';
import { connect } from 'react-redux';
import { firebase } from '../utils/firebase';
import { addUser, addAnimal } from '../redux/actions';
import { FirestoreCollection, FirestoreDocument } from 'react-firestore';
import Checkout from '../checkout';

const mapStateToProps = state => {
  const { user } = state;
  return {
    user,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onAddUserClick: user => {
      dispatch(addUser(user))
    },
    onAddAnimalClick: animal => {
      dispatch(addAnimal(animal))
    }
  }
};
 const Step1 = props => (
   <Form>

            <h2>Business Account</h2>
            <FormGroup>
              <Input type="email" name="email" id="exampleEmail" placeholder="Email" onChange={props.onHandleChange} invalid={props.authStatus}/>
              <FormFeedback invalid>Oops! That email is already attached to an account</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Input type="password" name="password" id="examplePassword" placeholder="Password" onChange={props.onHandleChange} invalid={props.invalidPassword} />
              <FormFeedback invalid>Password too weak! Needs to be more than 6 characters</FormFeedback>
            </FormGroup>
    </Form>
 )

export const Step2 = props => (
  <Form>
    <h2>Business Information</h2>
      <FormGroup>
              <Input type="text" name="name" id="name" defaultValue={ props.editForm ? props.name : props.name} placeholder="Business Name" onChange={props.onHandleChange} />
            </FormGroup>
             <FormGroup>
              <Label for="exampleAddress">Address</Label>
              <Input type="text" name="line1" id="exampleAddress" defaultValue={ props.editForm ? props.address.line1 : props.line1 } placeholder="Street Address" onChange={props.onHandleChange} />
              <Input type="text" name="line2" id="exampleAddress" defaultValue={ props.editForm ? props.address.line2 : props.line2 } placeholder="Apartment, Suite, Unit, etc." onChange={props.onHandleChange} />
              <Input type="text" name="city" id="exampleAddress" defaultValue={ props.editForm ? props.address.city : props.city } placeholder="City" onChange={props.onHandleChange} />
              <Input type="text" name="state" id="exampleAddress" defaultValue={ props.editForm ? props.address.state : props.state } placeholder="State/Province/Region" onChange={props.onHandleChange} />
              <Input type="number" name="zip" id="exampleAddress" defaultValue={ props.editForm ? props.address.zip : props.zip } placeholder="Zip Code" onChange={props.onHandleChange} />
              <Input type="text" name="country" id="exampleAddress" defaultValue={ props.editForm ? props.address.country : props.country } placeholder="Country" onChange={props.onHandleChange} />
            </FormGroup>
            <FormGroup>
              <Label for="primaryPhoneNumber">Number displayed on VERFID mobile application</Label>
              <Input type='tel' name="phoneNumberPrimary" id="phoneNumberPrimary" defaultValue={ props.editForm ? props.phoneNumberPrimary : props.phoneNumberPrimary } placeholder="Phone Number" onChange={props.onHandleChange} />
            </FormGroup>
            <FormGroup>
              <Input type='tel' name="website" id="phoneNumberPrimary" defaultValue={ props.editForm ? props.website : props.website } placeholder="Website URL" onChange={props.onHandleChange} />
            </FormGroup>
            <FormGroup>
              <Label for="exampleEmail">Email displayed on VERFID mobile application</Label>
              <Input type='email' name="email2" id="email2" defaultValue={ props.editForm ? props.email2 : props.email2 } placeholder="Public Email" onChange={props.onHandleChange} />
            </FormGroup>
            <FormGroup>
              <Label for="pin">6-8 Character Pin To Login On Mobile App</Label>
              <Input type='text' name="pin" id="pin" defaultValue={ props.editForm ? props.pin : props.pin } placeholder="Mobile App Scan Pin" onChange={props.onHandleChange} />
            </FormGroup>
            <FormGroup className="profileUploadBlock">
              <Label for="profileUpload">Upload Business Logo</Label>
              <input type="file" name="profileUpload" id="profileUpload" accept=".jpg, .png" onChange={props.handleProfileUpload} />
      </FormGroup>
  </Form>
)
const Step4 = props => (
       <div className="checkoutStep">
             <h2>Checkout</h2>
       <Input type="select" name="businessSize" onChange={props.onHandleChange}>
          <option value={5000}>Small ($50)</option>
          <option value={15000}>Medium ($150)</option>
          <option value={50000}>Large ($500)</option>
       </Input>
       <FormGroup>
        <Input type="text" name="promoCode" id="promoCode" placeholder="Promo Code" onChange={props.onHandleChange} />
       </FormGroup>
      {props.userPaidLogic? 
      <div>
      <h5>Thank you for your payment.</h5>
      <h5>Your account will not be created until you press submit.</h5> 
      </div>
               : <div classname="beforeSuccessfulPayment">
                <Checkout
                  description={"Setting up a VERFID account"}
                  userId={props.businessID}
                  onSuccess={() => props.userPaid()}
                  amount={props.businessSize}
                />
               
                 </div>}
        </div>
  );
 const Step3 = props => (
        <Form>
            <h2> Business Requirements</h2>
             <FormGroup>
              <Label>Are canines allowed in your business?</Label>
              <Input type="select" name="canineRestricted" onChange={props.onHandleChange} >
              <option value="true">No</option>
              <option value="false">Yes</option>
              </Input>
            </FormGroup>
            {(props.canineRestricted ==="false")? 
            <div>
             <FormGroup>
             <Label onClick={() => alert('A type of Assistance Animal that does work, performs tasks, provides assistance, and/or provides therapeutic emotional support for individuals with disabilities. A Support Animal is not a Service Animal.')}
             > Do they have to be a support canine? {'\u24d8'}</Label>
              <Input type="select" name="canineEmotionalSupportRequired" onChange={props.onHandleChange} >
                <option value="false">No</option>
                <option value="true">Yes</option>               
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="weight">Canine Maximum Weight (lbs)</Label>
              <Input type='select' name="canineWeightRestriction" id="weight" onChange={props.onHandleChange}>
                <option value={999}>No Limit</option>
                <option value={150}>150</option>
                <option value={100}>100</option>
                <option value={50}>50</option>
                <option value={30}>30</option>
                <option value={20}>20</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="animalColor" onClick={() => alert('The rabies vaccincation is required in almost all states \nThe next three are highly recommended for kennels and doggy daycares.')}>Select Required Canine Vaccines (What should I choose?)</Label>
               <FirestoreDocument
                  path={'vaccinations/canine'}
                  render={ ({ isLoading, data }) => {
                    const vaccines = isLoading ? null : data;
                   return isLoading ? (
                   <option>Loading</option> ) : (
                    <Input type="select" name="canineVaccineRestrictions" id="felineBreedRestrictions" placeholder="Restricted Feline Breeds" onChange={props.handleMultipleInputChange} multiple>
                        <option value='canineVac8'>{ vaccines['canineVac8'].name }: { vaccines['canineVac8'].info }</option>
                        <option value='canineVac0'>{ vaccines['canineVac0'].name }: { vaccines['canineVac0'].info }</option>
                        <option value='canineVac1'>{ vaccines['canineVac1'].name }: { vaccines['canineVac1'].info }</option>
                        <option value='canineVac2'>{ vaccines['canineVac2'].name }: { vaccines['canineVac2'].info }</option>
                        <option value='canineVac3'>{ vaccines['canineVac3'].name }: { vaccines['canineVac3'].info }</option>
                        <option value='canineVac4'>{ vaccines['canineVac4'].name }: { vaccines['canineVac4'].info }</option>
                        <option value='canineVac5'>{ vaccines['canineVac5'].name }: { vaccines['canineVac5'].info }</option>
                        <option value='canineVac7'>{ vaccines['canineVac7'].name }: { vaccines['canineVac7'].info }</option>
                    </Input>
                   )
                   }}
                  /> 
            </FormGroup>
            <FormGroup>
              <Label style={{ fontWeight: 'bold' }}>Vaccines Selected: (click to remove)</Label>
              { props.canineVaccineRestrictionsForDisplay.map((vaccine, index) => {
                return (
                  <text className="vaccineText" onClick={ () => props.removeVaccineItem(index, 'canine')}> { vaccine }, </text>
                )
              }) }
            </FormGroup>

                   
            <FormGroup>
              <Label for="exampleEmail">Select the canine breeds that are restricted from your business.</Label>
              <FirestoreDocument
                  path={'breeds/canine'}
                  render={ ({ isLoading, data }) => {
                    const breeds = isLoading ? null : data.data;
                   return isLoading ? (
                   <option>Loading</option> ) : (
                    <Input type="select" name="canineBreedRestrictions" id="exampleSelect" onChange={props.handleMultipleInputChange} multiple>
                      { breeds.map(breed => {
                        return <option value={breed}>{ breed }</option>
                      }) }
                    </Input>
                   )
                   }}
                  /> 
            </FormGroup>
            <FormGroup>
              <Label style={{ fontWeight: 'bold' }}>Canine Breeds Selected: (click to remove)</Label>
              { props.canineBreedRestrictionsForDisplay.map((vaccine, index) => {
                return (
                  <text className="vaccineText" onClick={ () => props.removeBreedItem(index, 'canine')}> { vaccine }, </text>
                )
              }) }
            </FormGroup>

            </div>
            :
            null
            }
            <FormGroup>
              <Label>Are felines allowed in your business?</Label>
              <Input type="select" name="felineRestricted" onChange={props.onHandleChange} >
                <option value="true">No</option>
                <option value="false">Yes</option>
              </Input>
            </FormGroup>
            {(props.felineRestricted ==="false")?
            <div>
             <FormGroup>
             <Label onClick={() => alert('A type of Assistance Animal that does work, performs tasks, provides assistance, and/or provides therapeutic emotional support for individuals with disabilities. A Support Animal is not a Service Animal.')}
          > Do they have to be a support feline? {'\u24d8'}</Label>
              <Input type="select" name="felineEmotionalSupportRequired" onChange={props.onHandleChange} >
               <option value="false">No</option>
               <option value="true">Yes</option>
              </Input>
            </FormGroup>

            <FormGroup>
                  
            <Label for="animalColor" onClick={() => alert('The rabies vaccincation is required in almost all states \nThe next three are highly recommended for kennels and doggy daycares.')} >Select Required Feline Vaccines (What should I choose?)</Label>
            <FirestoreDocument
                path={'vaccinations/feline'}
                render={ ({ isLoading, data }) => {
                  const vaccines = isLoading ? null : data;
                return isLoading ? (
                <option>Loading</option> ) : (
                  <Input type="select" name="felineVaccineRestrictions" id="felineBreedRestrictions" placeholder="Restricted Feline Breeds" onChange={props.handleMultipleInputChange} multiple>                                                
                      <option value='felineVac9'>{ vaccines['felineVac9'].name }: { vaccines['felineVac9'].info }</option>
                      <option value='felineVac0'>{ vaccines['felineVac0'].name }: { vaccines['felineVac0'].info }</option>
                      <option value='felineVac1'>{ vaccines['felineVac1'].name }: { vaccines['felineVac1'].info }</option>
                      <option value='felineVac2'>{ vaccines['felineVac2'].name }: { vaccines['felineVac2'].info }</option>
                      <option value='felineVac3'>{ vaccines['felineVac3'].name }: { vaccines['felineVac3'].info }</option>
                      <option value='felineVac4'>{ vaccines['felineVac4'].name }: { vaccines['felineVac4'].info }</option>
                      <option value='felineVac5'>{ vaccines['felineVac5'].name }: { vaccines['felineVac5'].info }</option>
                      <option value='felineVac7'>{ vaccines['felineVac7'].name }: { vaccines['felineVac7'].info }</option>
                      <option value='felineVac8'>{ vaccines['felineVac8'].name }: { vaccines['felineVac8'].info }</option>
                  </Input>
                )
                }}
                /> 
            </FormGroup>
            <FormGroup>
              <Label style={{ fontWeight: 'bold' }}>Vaccines Selected: (click to remove)</Label>
               { props.felineVaccineRestrictionsForDisplay.map((vaccine, index) => {
                return (
                  <text className="vaccineText" onClick={ () => props.removeVaccineItem(index, 'feline')}> { vaccine }, </text>
                )
              }) }
            </FormGroup>

            <FormGroup>
              <Label for="exampleEmail">Select the feline breeds that are restricted from your business.</Label>
              <FirestoreDocument
                  path={'breeds/feline'}
                  render={ ({ isLoading, data }) => {
                    const breeds = isLoading ? null : data.data;
                   return isLoading ? (
                   <option>Loading</option> ) : (
                    <Input type="select" name="felineBreedRestrictions" id="exampleSelect" onChange={props.handleMultipleInputChange} multiple>
                      { breeds.map(breed => {
                        return <option>{ breed }</option>
                      }) }
                    </Input>
                   )
                   }}
                  /> 
            </FormGroup>

            <FormGroup>
              <Label style={{ fontWeight: 'bold' }}>Feline Breeds Selected: (click to remove)</Label>
              { props.felineBreedRestrictionsForDisplay.map((vaccine, index) => {
                return (
                  <text className="vaccineText" onClick={ () => props.removeBreedItem(index, 'feline')}> { vaccine }, </text>
                )
              }) }
            </FormGroup>

                </div>
              :
              null
            }
            
          
          
          
            <FormGroup>
              <Label>Do you require a Veterinary Health Certificate?</Label>
              <Input type="select" name="requireVeterinaryHealthCertificate" onChange={props.onHandleChange} >
                <option value="false">No</option>
                <option value="true">Yes</option>               
              </Input>
              </FormGroup>
       
            <FormGroup>
              <Label for="minimumMonthsOfOwnership">How long do you require the owner to own the animal before entering your business? (months)</Label>
              <Input type="number" name="minimumMonthsOfOwnership" max="500" min="0" placeholder="0" onChange={props.onHandleChange} />
            </FormGroup>
            <FormGroup>
              <Label for="minimumMonthsOfAge">How old does the animal need to be to enter your business? (months) </Label>
              <Input type="number" name="minimumMonthsOfAge" max="500" min="0" placeholder="0" onChange={props.onHandleChange} />
            </FormGroup>

              <FormGroup>
              <Label onClick={() => alert('By choosing Yes, only animal owners that agree to the following statement will be allowed in your business. \n \nAnimal Behavior and Liability Statement \n \nBy checking this box you confirm that your animal has never caused serious bodily or psychological harm to a human or other animal, does not act aggressively or maliciously to humans or other animals, is not considered a nuisance to humans or other animals, and is considered well-behaved in public settings. \nTo the best of your knowledge, your animal is free from any contagious diseases or conditions that would make it a danger to another animal or human. You understand that VERFID LLC, its members, business associates, and participating Business Account holders are not responsible for the behavior or actions of your animal. Without exception, you accept full responsibility for any damage(s) to persons, animals, or properties as a result of actions caused by your animal. ')}
              >Do you require an 'Animal Behavior and Liability Statement' to enter your business? (View Statement)</Label>
              <Input type="select" name="forceLiabilityAgreement" onChange={props.onHandleChange} >
                <option value="true">Yes</option>
                <option value="false">No</option>
              </Input>
            </FormGroup>
           
           
    </Form>
  );
class AnimalRegistration extends Component {
    constructor(props) {
      super(props)

      this.state = {
        formStatus: '',
        authStatus: false,
        invalidPassword: false,
        name: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip: '',
        email: '',
        email2: '',
        password: '',
        address: '',
        firstName: '',
        lastName: '',
        animalName: '', 
        animalColor: '',
        animalType: 'dogBreeds',
        breed: '',
        pin: '',
        file: null,
        profileImage: null,
        dogImage: null,
        step: 1,
        userPaid: false,
        businessSize: 5000,
        canineWeightRestriction: 999,
        felineWeightRestriction: 50,
        weightRestriction: '',
        minimumMonthsOfOwnership: 0,
        minimumMonthsOfAge: 0,
        felineVaccineRestrictions: [],
        felineVaccineRestrictionsForDisplay: [],
        canineVaccineRestrictions: [],
        canineVaccineRestrictionsForDisplay: [],
        felineBreedRestrictions: [],
        felineBreedRestrictionsForDisplay: [],
        canineBreedRestrictions: [],
        canineBreedRestrictionsForDisplay: [],
        successfulAccountCreation: false,
        canineEmotionalSupportRequired: "false",
        felineEmotionalSupportRequired: "false",
        requireVeterinaryHealthCertificate: "false",
        forceLiabilityAgreement: "true",
      }
      this.handleSubmit = this.handleSubmit.bind(this)
      this.onHandleChange = this.onHandleChange.bind(this)
      this.handleFileChange = this.handleFileChange.bind(this)
      this.handleProfileUpload = this.handleProfileUpload.bind(this)
      this.handleMultipleChange = this.handleMultipleChange.bind(this)
      this.nextStep = this.nextStep.bind(this)
      this.lastStep = this.lastStep.bind(this)
    }

   

handleFileChange(fileUploaded) {
  this.setState({
    file: fileUploaded.base64
  })
}

handleMultipleChange(e) {
 
      var name = e.target.name;
      var item = e.target.value;
      var itemToDisplay = e.target.options[e.target.options.selectedIndex].innerHTML;

      if(name === 'felineVaccineRestrictions') {
        var values = this.state.felineVaccineRestrictions;
        var valuesToDisplay = this.state.felineVaccineRestrictionsForDisplay;
        var nameForDisplay = 'felineVaccineRestrictionsForDisplay';
      } else if (name === 'canineVaccineRestrictions') {
        var values = this.state.canineVaccineRestrictions;
        var valuesToDisplay = this.state.canineVaccineRestrictionsForDisplay;
        var nameForDisplay = 'canineVaccineRestrictionsForDisplay';
      } else if(name === 'felineBreedRestrictions') {
        var values = this.state.felineBreedRestrictions;
        var valuesToDisplay = this.state.felineBreedRestrictionsForDisplay;
        var nameForDisplay = 'felineBreedRestrictionsForDisplay';
      } else {
        var values = this.state.canineBreedRestrictions;
        var valuesToDisplay = this.state.canineBreedRestrictionsForDisplay;
        var nameForDisplay = 'canineBreedRestrictionsForDisplay';
      }
      if (values.indexOf(item) < 0) {
        values.push(item);
      };
      if (valuesToDisplay.indexOf(itemToDisplay) < 0) {
        valuesToDisplay.push(itemToDisplay)
      }
     this.setState({
       [name]: values,
       [nameForDisplay]: valuesToDisplay,
     })
  }
  removeVaccineItem = (index, type) => {
    if(type === 'canine'){
      var values = this.state.canineVaccineRestrictions;
      var valuesToDisplay = this.state.canineVaccineRestrictionsForDisplay;
      var name = 'canineVaccineRestrictions'
      var nameForDisplay = 'canineVaccineRestrictionsForDisplay';
    } else {
      var values = this.state.felineVaccineRestrictions;
      var valuesToDisplay = this.state.felineVaccineRestrictionsForDisplay;
      var name = 'felineVaccineRestrictions'
      var nameForDisplay = 'felineVaccineRestrictionsForDisplay';
    }
    values.splice(index, 1);

    valuesToDisplay.splice(index, 1);

    this.setState({
      [name]: values,
      [nameForDisplay]: valuesToDisplay,
    });
  }
  removeBreedItem = (index, type) => {
    if (type === 'canine') {
      var values = this.state.canineBreedRestrictions;
      var valuesToDisplay = this.state.canineBreedRestrictionsForDisplay;
      var name = 'canineBreedRestrictions'
      var nameForDisplay = 'canineBreedRestrictionsForDisplay';
    } else {
      var values = this.state.felineBreedRestrictions;
      var valuesToDisplay = this.state.felineBreedRestrictionsForDisplay;
      var name = 'felineBreedRestrictions'
      var nameForDisplay = 'felineBreedRestrictionsForDisplay';
    }
    values.splice(index, 1);

    valuesToDisplay.splice(index, 1);

    this.setState({
     [name]: values,
     [nameForDisplay]: valuesToDisplay,
    });
  }
  handleProfileUpload(e) {    
    this.setState({
      profileImage: e.target.files[0],
    });
  };
  handleSubmit(props) {
    var db = firebase.firestore();
    var storageRef = firebase.storage().ref()
    var file = this.state.profileImage;
    var canineRestricted = this.state.canineRestricted === "true" ? true : false;
    var felineRestricted = this.state.felineRestricted === "true" ? true : false;
    var boolForcedLiability = this.state.forceLiabilityAgreement === "true" ? true : false;
    var canineEmotionalSupportRequired = this.state.canineEmotionalSupportRequired === "true" ? true : false;
    var felineEmotionalSupportRequired = this.state.felineEmotionalSupportRequired === "true" ? true : false;
    var healthCert = this.state.requireVeterinaryHealthCertificate === "false" ? false : true;
    var list = [''];
    var list2 = [''];
    canineEmotionalSupportRequired ? list.unshift('canineCert1'): null;
    healthCert ? list.unshift('canineCert0') : null;
    felineEmotionalSupportRequired ? list2.unshift('felineCert1'): null;
    healthCert ? list2.unshift('felineCert0') : null;
    // adding the business
    db.collection('businesses').doc(`${this.state.businessID}`).set({
      name: this.state.name,
      email: this.state.email,
      emailPublic: this.state.email2,
      pin: this.state.pin,
      address: {
        city: this.state.city,
        state: this.state.state,
        line1: this.state.line1,
        line2: this.state.line2 || '',
        country: this.state.country || 'United States',
        zip: this.state.zip,
      },
      phoneNumberPrimary: this.state.phoneNumberPrimary,
      website: this.state.website,
      businessId: this.state.businessID,
      imageUrl: '',
    })
    // adding the canine restrictions

      .then(docRef => db.collection('businesses').doc(`${this.state.businessID}`).collection('requirements').doc('canine').set({
      vaccinations: this.state.canineVaccineRestrictions,
      maximumWeight: parseInt(this.state.canineWeightRestriction),
      restrictedBreeds: this.state.canineBreedRestrictions,
      businessId: this.state.businessID,
      minimumMonthsOfOwnership: parseInt(this.state.minimumMonthsOfOwnership),
      minimumMonthsOfAge: parseInt(this.state.minimumMonthsOfAge),
      restricted: canineRestricted,
      forms: boolForcedLiability ? ['canineForm0'] : [''],
      certificates:list, 
      }))
    // adding the feline restrictions
      .then(docRef => db.collection('businesses').doc(`${this.state.businessID}`).collection('requirements').doc('feline').set({
        vaccinations: this.state.felineVaccineRestrictions,
        maximumWeight: parseInt(this.state.felineWeightRestriction),
        restrictedBreeds: this.state.felineBreedRestrictions,
        businessId: this.state.businessID,
        minimumMonthsOfOwnership: parseInt(this.state.minimumMonthsOfOwnership),
        minimumMonthsOfAge: parseInt(this.state.minimumMonthsOfAge),
        restricted: felineRestricted,
        forms: boolForcedLiability ? ['felineForm0'] : [''],
        certificates: list2,

      }))
         .then(docRef => {
           this.uploadBusinessProfiePic();
         })
      .then(() => {
            this.setState({
              successfulAccountCreation: true,
            });
      })
    .catch(error => console.error('this is the error: ', error));
    // e.preventDefault();    
  }
  uploadBusinessProfiePic = () => {
    var storageRef = firebase.storage().ref();
    var profilePicture = this.state.profileImage;
    var db = firebase.firestore();
    const uploadTask = storageRef.child(`profileImage/${this.state.businessID}`).put(profilePicture); //create a child directory called images, and place the file inside this directory
    uploadTask.on('state_changed', (snapshot) => {
      // Observe state change events such as progress, pause, and resume
    }, (error) => {
      // Handle unsuccessful uploads
    }, () => {
      // Do something once upload is complete
      uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
        db.collection('businesses').doc(`${this.state.businessID}`).update({
          imageUrl: downloadURL,
        })
      });
    });
  }

  successfulPayment = () => {
    firebase.database().ref('/payments/' + this.state.businessID).on('value', snapshot => {
      if (snapshot) {
        this.setState({
          userPaid: true,
        })
      };
    });
  }

  onHandleChange(e) {
    var name = e.target.name;
    var value = e.target.value;
        if (name === 'password' && value.length < 6) {
          this.setState({
            invalidPassword: true,
          })
        } else if (name === 'businessSize') {
          var businessMoney = parseInt(value);
          this.setState({
            [name]: businessMoney,
          })
        } else {
          this.setState({
            [name]: value,
            invalidPassword: false,
          });
        }

        if(name === 'promoCode' && value === 'free99'){
          this.setState({
            userPaid: true,
          })
          alert('Congratulations on your free business account! Please remember to press submit to finish creating the account.')
        }

  }
  nextStep(){
    if(this.state.step === 1) {
      firebase.auth().createUserWithEmailAndPassword(this.state.email, this.state.password)
      .then(snapshot => {      
        this.setState({
          businessID: snapshot.user.uid,
        })
        firebase.auth().currentUser.updateProfile({
          displayName: "Business",
        }).catch(err => {
        })
        .then(()=>{          
          firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password);
          var increment = this.state.step + 1;
          this.setState({
            step: increment,
          })
        })

        firebase.auth().currentUser.sendEmailVerification().catch(err => console.log(err))
        
      })
      .catch( err => {
          alert('Email is already used by an account!')
          this.setState({
            authStatus: 'true'
          })
        })
    } else {
      var increment = this.state.step + 1;
      
      this.setState({
          step: increment
      })

    }
  }
  lastStep(){
   if(this.state.step > 1){
      var decrement = this.state.step - 1
    } else {
      var decrement = 1;
    }

    this.setState({
      step: decrement
    })
  }

  componentDidMount() {
   /* firebase.auth().onAuthStateChanged(function (user) {
      /*if (user) {
        // User is signed in.
        firebase.auth().signOut().then(function () {
          // Sign-out successful.
        }).catch(function (error) {
          // An error happened.
        });
      } else {
        // No user is signed in.
      }
    }); */
  }
  showStep(props) {
    const onHandleChangeProps = this.onHandleChange;
    const onHandleFileChange = this.handleFileChange;
    const handleProfileUploadProps = this.handleProfileUpload;
    const handleMultipleChange = this.handleMultipleChange;
    const removeBreedItem = this.removeBreedItem;
    const removeVaccineItem = this.removeVaccineItem;
    const userPaid = this.successfulPayment;

    switch (this.state.step) {
      case 1:
      return <Step1 {...props} onHandleChange={onHandleChangeProps}  handleProfileUpload={handleProfileUploadProps} handleMultipleInputChange={handleMultipleChange} />
      case 2:
      return <Step2 {...props}  onHandleChange={onHandleChangeProps} handleFileChange={onHandleFileChange} handleProfileUpload={handleProfileUploadProps} />
      case 3:
      return <Step3 {...props} removeBreedItem={removeBreedItem} removeVaccineItem={removeVaccineItem} onHandleChange={onHandleChangeProps} handleMultipleInputChange={handleMultipleChange} handleFileChange={onHandleFileChange} canineRestricted={this.state.canineRestricted} felineRestricted={this.state.felineRestricted} />
      case 4: 
        return <Step4 {...props} onHandleChange={onHandleChangeProps} userPaid={userPaid} userPaidLogic={this.state.userPaid} />
      default: 
        return <Step1 {...props} />
    };
  }
  render() {
    var style = {
      width : (this.state.step / 4 * 100) + '%'
    }
    return (
      <div>
        { this.state.successfulAccountCreation ? 
        <div id="stepDiv">
        <h1>Account Successfully Created!</h1>
        </div> :
        <div>
        <progress className="progress" style={style}></progress>
       <div id="stepDiv">
        {this.showStep(this.state)}
        </div>
        <div id="nextStepButtonDiv">
          <Button onClick={this.lastStep}>{this.state.step===1? <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div> : "Last"}</Button>
          <Button disabled={this.state.invalidPassword || (this.state.step ===2 && this.state.profileImage===null) || (this.state.step === 4 && !this.state.userPaid)} onClick={this.state.step === 4 ? this.handleSubmit : this.nextStep}>{ this.state.step === 4 ? 'Submit' : 'Next' }</Button>
        </div> 
        </div>
      }
      </div>
      )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AnimalRegistration);



// WEBPACK FOOTER //
// ./src/components/businessAccountRegistration.js